var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVertical)?_c('router-view'):_c('custom-horizontal')}
var staticRenderFns = []

export { render, staticRenderFns }